import { Link } from "react-router-dom";
import ArrowRightIcon from "../../../assets/icons/arrow-right-desktop.svg";
import { useForgotPassword } from "../hooks/useForgotPassword";
import styles from "../Auth.module.css";

// Brand wordmark served from /public (PQ VPN Enterprise).
const LOGO_SRC = `${process.env.PUBLIC_URL}/Logo.svg`;

// ── Forgot password ───────────────────────────────────────────────────────────
// Step 1 of the reset flow. Collects the email and calls
// POST /auth/forgot-password (enterprise backend). The reset link the backend
// emails lands on /reset-password (see ResetPasswordPage).
export default function ForgotPasswordPage() {
  const { email, setEmail, loading, error, sent, submit } = useForgotPassword();

  return (
    <div className={styles.page}>
      <div className={styles.bg} />

      <div className={styles.loginCard}>

        {/* ── Logo ── */}
        <div className={styles.loginLogo}>
          <img src={LOGO_SRC} alt="PQ VPN Enterprise" />
        </div>

        {/* ── Dashed divider ── */}
        <div className={styles.loginDivider} />

        {/* ── Title ── */}
        <h2 className={styles.loginTitle}>Reset password</h2>

        {sent ? (
          /* ─── Neutral confirmation (no account enumeration) ─── */
          <>
            <div className={styles.infoBanner}>
              If an account exists for {email}, we've sent a link to reset your password.
              Check your inbox and follow the link to continue.
            </div>
            <div className={styles.authLinkRow}>
              <Link to="/login" className={styles.loginForgot}>Back to sign in</Link>
            </div>
          </>
        ) : (
          <>
            {/* ── Error banner ── */}
            {error && <div className={styles.errorBanner}>{error}</div>}

            <form className={styles.loginForm} onSubmit={submit}>
              <div className={styles.loginFormFields}>
                <div className={styles.floatingField}>
                  <input
                    id="email"
                    className={styles.loginInput}
                    type="email"
                    placeholder=" "
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                  <label htmlFor="email" className={styles.floatingLabel}>Email</label>
                </div>
              </div>

              {/* Submit button */}
              <button type="submit" className={styles.loginSubmitBtn} disabled={loading}>
                {loading
                  ? <span className={styles.spinner} />
                  : <>
                    <span>Send reset link</span>
                    <img src={ArrowRightIcon} alt="" className={styles.loginBtnIcon} />
                  </>}
              </button>
            </form>

            {/* Back to sign in */}
            <div className={styles.authLinkRow}>
              <Link to="/login" className={styles.loginForgot}>Back to sign in</Link>
            </div>
          </>
        )}
      </div>

      <footer className={styles.footer}>
        <span>© 2026 NPQ VPN. All rights reserved.</span>
      </footer>
    </div>
  );
}
